import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';
import { TranslateService } from '@ngx-translate/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-repairqualification',
  templateUrl: './repairqualification.component.html',
  styleUrls: ['./repairqualification.component.scss']
})
export class RepairqualificationComponent implements OnInit {
  public isControl: boolean = false;
  public isRepair: boolean = false;
  public isPostRepair: boolean = false;
  public casualPartEmpty: boolean = false;
  public sessionId: any;
  public repair: any;
  public tokenObj: any;
  public dealerCode = '';
  public vinNumber: any;
  public isShowPartsKit: boolean = false;
  public repairCount = 0;
  public postRepairCount = 0;
  public testedRepairCount: number = 0;
  public testedPostRepairCount:number = 0;
  public repairBtnState = "GO";
  public postRepairBtnState = "GO";
  public isShowRepairComplete: boolean = false;
  public listofpartskit: any = [];
  public partskitdata: any = [];
  public noWarratyCode: boolean = false;
  public partsKit: any;
  public partsquantity: any;
  public warrantyKitCode: any;
  public casualPart: any;
  vin: any
  countrythree: any
  modelYear: any
  username: any
  vindetails: any
  vehicle: any
  language: any
  country: any
  isShowRVC: boolean = false;
  repairQualificationSubscription:Subscription = new Subscription;
  controlSubscription: Subscription = new Subscription;
  repairProcedureSubscription: Subscription = new Subscription;
  gIdRepairSubscription: Subscription = new Subscription;
  postRepairProcedureSubscription: Subscription = new Subscription;
  gIdPostRepairSubscription: Subscription = new Subscription;
  tokenSubscription: Subscription = new Subscription;
  RVCSubscription: Subscription = new Subscription;
  viewRepairQualification: boolean = false;
  repairPostRepair: any;
  showNoRVCInfo: boolean = false;
  info: any;
  isButtonEnabled : boolean = true;
  showCustomerPaidDesc: boolean = false;
  @ViewChild('noRVCMsgInfo') noRVCMsgInfo: ElementRef;
  constructor(private service: ApifirstService, private router: Router, private rpcClient: RpcClientService, private translate: TranslateService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.service.setShowWhatsNew(false);
    this.sessionId = localStorage.getItem("sessionID");

    this.info = this.translate.instant('NoRVCInfo')+":" + "  "
    + "1." + " " + this.translate.instant('Rule1') + "  "
    + "2." + " " + this.translate.instant('Rule2') + "  "
    + "3." + " " + this.translate.instant('Rule3') + "  "
    + "4." + " " + this.translate.instant('Rule4') + "  "
    +"." + " " + this.translate.instant('NoRVCInfo1');

    this.tokenSubscription = this.service.tokenObj.subscribe((data) => {
      this.tokenObj = data
      this.dealerCode = this.tokenObj.dealerCode
      this.vinNumber = this.tokenObj.vin
      let c: any
      c = data
      this.language = c.language
      this.country = c.country
      this.dealerCode = c.dealerCode
      this.countrythree = c.countryThree
      this.vin = c.vin
      this.username = c.username
    })

    this.RVCSubscription = this.service.resumeRVC.subscribe((data) => {
      this.isShowRVC = data;
    })

    this.gIdRepairSubscription = this.service.storeGidRepair.subscribe((data) => {
      this.testedRepairCount = data.length;
    })

    this.gIdPostRepairSubscription = this.service.storeGidPostRepair.subscribe((data) => {
      this.testedPostRepairCount = data.length;
    })

    this.repairProcedureSubscription = this.service.isRepairProcedure.subscribe((data) => {
      this.isRepair = data;
    })

    this.postRepairProcedureSubscription = this.service.isPostRepairProcedure.subscribe((data) => {
      this.isPostRepair = data;
    })

    this.controlSubscription = this.service.control.subscribe((data) => {
      this.isControl = data;
    })

    this.repairQualificationSubscription = this.service.repairQualificationData.subscribe((data)=> {
      this.repair = data;
      console.log('Repair qualification Data:---------', this.repair);
      this.repairCount = this.repair.repair;
      this.postRepairCount = this.repair.postRepair;
      if (this.repair.rvcCode == null) {
        this.repair.rvcCode = "No RVC Required";
      }
      if(this.repair.rvcCode == 'RVC not required') {
        this.repair.rvcCode = 'No RVC Required';
        this.showCustomerPaidDesc = false;
      }

      if(this.repair.rvcCode == 'Contact Helpdesk') {
        this.repair.rvcCode = 'Contact_Helpdesk';
        this.showCustomerPaidDesc = false;
      }

      if(this.repair.rvcCode == 'Customer paid') {
        this.repair.rvcCode = 'Customer_Paid';
        this.showCustomerPaidDesc = true;
      }

      if(this.repair.rvcCode == 'No RVC' || this.repair.rvcCode == null || this.repair.rvcCode == 'No RVC Required' || this.repair.rvcCode == 'Contact_Helpdesk') {
        this.showNoRVCInfo = true;
      }
      this.showHideRepairCompleteBtnOnClickGo();
    })

    if (!this.isShowRVC) {
      //update page number
      const req = {
        "sessionId": this.sessionId,
        "pageid": "11"
      }
      this.service.updatePage(req).subscribe(data => { })
    }
    if (!this.isShowRepairComplete && !this.isShowRVC) {
      this.getPartsKitInfo();
    }
  }

  view(value: number) {
    this.rpcClient.HideFDRSIconIfNotConnected();
    if (value == 1) {
      this.viewRepairQualification = true;
      this.service.repairQualificationViewBtnClick(this.sessionId).subscribe((data) => {
        console.log('View Qualifivation data----------------:',data);
        this.service.repairQualificationData.next(data);
        this.service.resumeRVC.next(true);
        this.viewRepairQualification = false;
        console.log("On View {} ", this.repair.rvcCode);
        if(this.repair.rvcCode == 'No RVC' || this.repair.rvcCode == null || this.repair.rvcCode == 'No RVC Required' || this.repair.rvcCode == 'RVC not required') {
          this.modalService.open(this.noRVCMsgInfo, { size: 'md' });
          this.disableButtonAfterModalOpen();
        }
      })
      //update page number
      const req = {
        "sessionId": this.sessionId,
        "pageid": "16"
      }
      this.service.updatePage(req).subscribe(data => { })
    } else if (value == 2) {
      this.service.fromResume.next(false);
      const req = {
        "sessionId": this.sessionId,
      }
      this.viewRepairQualification = true;
      this.service.getRepairDetails(req).subscribe((data) => {
        this.repairPostRepair = data;
        this.callRepairPostRepairGo('repair');
        this.viewRepairQualification = false;
        this.router.navigate(['/repairProcedures']);
      })
    } else if (value == 3) {
      this.service.fromResume.next(false);
      const req = {
        "sessionId": this.sessionId,
      }
      this.viewRepairQualification = true;
      this.service.getPostRepairDetails(req).subscribe((data) => {
        this.repairPostRepair = data;
        this.callRepairPostRepairGo('postRepair');
        this.viewRepairQualification = false;
        this.router.navigate(['/postrepairProcedures']);
      })
    }
  }

  disableButtonAfterModalOpen() {
    setTimeout(() => {
      this.isButtonEnabled = false;
    }, 3000);
  }

  showHideRepairCompleteBtnOnClickGo() {
    this.rpcClient.HideFDRSIconIfNotConnected();
    if (this.isControl && this.repairCount == 0 && this.postRepairCount == 0) {
      this.isShowRepairComplete = true;
    } else if (this.isControl && this.repairCount == 0) {
      if (!this.isPostRepair || ((this.postRepairCount == this.testedPostRepairCount))) {
        this.isShowRepairComplete = true;
        this.isPostRepair = false;
        this.postRepairBtnState = "DONE";
      }
    } else if (this.isControl && this.postRepairCount == 0) {
      if (!this.isRepair || ((this.repairCount == this.testedRepairCount))) {
        this.isShowRepairComplete = true;
        this.isRepair = false;
        this.repairBtnState = "DONE";
      }
    } else if (this.isControl) {
      if ((!this.isRepair && !this.isPostRepair) || ((this.postRepairCount == this.testedPostRepairCount))) {
        this.isShowRepairComplete = true;
        this.isRepair = false;
        this.isPostRepair = false;
        this.postRepairBtnState = "DONE";
        this.repairBtnState = "DONE";
      } else if (!this.isRepair || ((this.repairCount == this.testedRepairCount))) {
        this.isRepair = false;
        this.isPostRepair = true;
        this.repairBtnState = "DONE";
      }
    }
  }

  callRepair() {
    const req = {
      "sessionId": this.sessionId,
      "pageid": "11"
    }
    this.service.updatePage(req).subscribe(data => { })
    this.service.control.next(true);
    if (this.repairCount > 0) {
      this.service.isRepairProcedure.next(true);
    } else if (this.postRepairCount > 0) {
      this.service.isPostRepairProcedure.next(true);
    }
    this.viewRepairQualification = true;
    this.service.getContinueDetails(this.sessionId, true).subscribe((data) => {
      this.showHideRepairCompleteBtnOnClickGo();
      if (!this.isShowRepairComplete) {
        this.getPartsKitInfo();
      }
      this.service.resumeRVC.next(false);
      this.viewRepairQualification = false;
    })
  }

  getPartsKitInfo() {
    this.partskitdata = [];
    this.service.partskitinfo(this.sessionId).subscribe((data) => {
      this.partskitdata = data;
      if (this.partskitdata.length > 0) {
        for (let i of this.partskitdata) {
          this.listofpartskit = i.parts;
        }
        this.partsKit = this.partskitdata[0].partsKit;
        this.warrantyKitCode = this.partskitdata[0].warrantyKitCode;
        this.partsquantity = this.partskitdata[0].quantity;
        this.casualPart = this.partskitdata[0].casualPart;
        if (this.partskitdata[0].showWarrantyKit == true || this.listofpartskit.length > 0) {
          this.isShowPartsKit = true;
        } else {
          this.isShowPartsKit = false;
        }
        if (this.partskitdata[0].showWarrantyKit == true) {
          this.noWarratyCode = true;
        } else {
          this.noWarratyCode = false;
        }
        if (this.partskitdata[0].hasCasualPart == false) {
          this.casualPartEmpty = true;
        } else {
          this.casualPartEmpty = false;
        }
      } else {
        this.isShowPartsKit = false;
      }
    }, (err) => {
      this.isShowPartsKit = false;
    })
  }

  callRepairPostRepairGo(screen: string) {
    let gIdArray: any = [];
    for (let candidate of this.repairPostRepair) {
      if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
        if (candidate.result.state == "pass" || candidate.result.state == 'fail') {
          gIdArray.push(candidate.procRef.procUidRef);
          candidate.result.state = 'Tested';
        } else if (candidate.result.state == 'Error') {
          gIdArray.push(candidate.procRef.procUidRef);
          candidate.result.state = 'Error';
        } else if (candidate.result.state == 'abort') {
          gIdArray.push(candidate.procRef.procUidRef);
          candidate.result.state = 'Aborted';
        } else {
          candidate.result.state = 'Untested';
        }
      } else if (candidate.result.state == 'pass') {
        gIdArray.push(candidate.procRef.procUidRef);
        candidate.result.state = 'Viewed';
      } else if (candidate.result.state == 'Error') {
        gIdArray.push(candidate.procRef.procUidRef);
        candidate.result.state = 'Error';
      } else {
        candidate.result.state = 'Unread';
      }
    }
    if(screen === 'repair') {
      this.service.storeGidRepair.next(gIdArray);
      this.service.repairObj.next(this.repairPostRepair);
    } else {
      this.service.storeGidPostRepair.next(gIdArray);
      this.service.postRepairObj.next(this.repairPostRepair);
    }
  }

  navigateToStartDiag() {
    this.rpcClient.HideFDRSIconIfNotConnected();
    this.viewRepairQualification = true;
    localStorage.setItem("component", "fromNetworkTest");
    this.service.navigatePreviousScreen.next('');
    this.service.isFromRepairComplete.next(true);
    this.service.repairCompleteBtnClick(this.sessionId).subscribe((data) => {
      this.viewRepairQualification = false;
      this.router.navigate(["/closeCanceldiagnosis"]);
    })
  }

  ngOnDestroy() {
    this.repairQualificationSubscription.unsubscribe();
    this.controlSubscription.unsubscribe();
    this.repairProcedureSubscription.unsubscribe();
    this.gIdRepairSubscription.unsubscribe();
    this.postRepairProcedureSubscription.unsubscribe();
    this.gIdPostRepairSubscription.unsubscribe();
    this.tokenSubscription.unsubscribe();
    this.RVCSubscription.unsubscribe();
  }

  downloadPageAsPdf(): void {
  const element: HTMLElement = document.body;

  const opt: any = {
    margin: [12, 12, 12, 12],
    filename: 'Page-Report.pdf',
    image: { type: 'jpeg', quality: 0.95 },
    html2canvas: { scale: 1.25, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  // html2pdf loaded via CDN
  // @ts-ignore
  if (typeof html2pdf !== 'undefined') {
    // @ts-ignore
    html2pdf().from(element).set(opt).save();
  } else {
    window.print();
  }
}

printPageNative(): void {
  window.print();
}
}
